<h2 mat-dialog-title>{{ "await.Await" | translate }}</h2>
<mat-dialog-content>
  <div class="row">
    <form class="w-100" [formGroup]="expForm" #formDirective="ngForm">
      <div class="col">
        <mat-form-field>
          <mat-label class="required-field">{{
            "await.Reason" | translate
          }}</mat-label>
          <textarea
            matInput
            rows="6"
            id="str"
            formControlName="reason"
            (input)="str = $event.target.value"
          ></textarea>
          <mat-error *ngIf="!str">{{
            "await.Please_enter_a_reason_for_awaiting" | translate
          }}</mat-error>
          <mat-error *ngIf="str && formInvalid()">{{
            "await.Please_provide_a_valid_reason" | translate
          }}</mat-error>
        </mat-form-field>
      </div>

      <div *ngIf="awaitPeriodRequired" class="col">
        <mat-form-field>
          <mat-label>Await Period</mat-label>
          <input
            [min]="minDate"
            matInput
            [ngxMatDatetimePicker]="picker"
            formControlName="awaitperiod"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <ngx-mat-datetime-picker
            #picker
            [showSeconds]="true"
          ></ngx-mat-datetime-picker>
        </mat-form-field>
      </div>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="float-end">
  <div class="buttons">
    <button
      mat-button
      mat-raised-button
      preventDoubleClick
      color="primary"
      (click)="onAwait()"
      [disabled]="!str || formInvalid()"
      class="two"
    >
      {{ "await.Await" | translate }}
    </button>
    <button mat-raised-button mat-dialog-close class="one">
      {{ "await.Cancel" | translate }}
    </button>
  </div>
</mat-dialog-actions>
